import { useEffect, useState } from 'react'

const LICENSES_REPORT_PATH = './third_party_library_license_report.json'

const useLibraries = () => {
  const [libraries, setLibraries] = useState(null)
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    fetch(LICENSES_REPORT_PATH)
      .then((r) => r.json())
      .then((r) => setLibraries(r))
      .catch(() => setLibraries(null))
      .finally(() => setIsLoaded(true))
  }, [])

  return { libraries, isLoaded }
}

export default useLibraries
